import React from 'react';
import { TextField as MuiTextField, InputAdornment } from '@mui/material';
import { EditOutlined } from '@mui/icons-material';
import { inputSx, multilineInputSx } from '../../styles/wizardSx';

function TextField({ field, value, onChange, ...props }) {
  return (
    <MuiTextField
      fullWidth
      label={field.label}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      multiline={field.type === 'textarea'}
      rows={field.type === 'textarea' ? 3 : 1}
      type={
        field.type === 'email' ? 'email' :
        field.type === 'url' ? 'url' :
        'text'
      }
      sx={field.type === 'textarea' ? multilineInputSx : inputSx}
      InputProps={{
        startAdornment: field.type !== 'textarea' && (
          <InputAdornment position="start">
            <EditOutlined sx={{ color: 'primary.main', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
}

export default TextField;
